<template>
<div>


<div class="row">
          <div class="col s4 m12"><img src="../assets/logo.png" style="height:80px;"/></div>
          <div class="col s8 m12"><h2>{{$socio.contatto.row.cognome}} {{$socio.contatto.row.nome}}</h2> </div>
        </div>
        
<!--
  Benvenuti alla procedura online .....
  <br />
  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris aliquet non est quis accumsan. Proin imperdiet, ipsum in ultrices convallis, leo urna posuere neque, eget facilisis nunc urna et magna. Mauris id pharetra ex. Sed molestie metus vitae libero tempor ornare. Maecenas feugiat hendrerit pulvinar. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Phasellus pretium ex vitae tincidunt semper. In quis enim tincidunt, vehicula est ut, efficitur arcu. Phasellus commodo elit purus, vitae pretium mauris fermentum vel. Proin accumsan, sem non tempus feugiat, libero dui blandit quam, sit amet porta diam elit sed lacus. Proin porta ex sit amet augue accumsan tempus. Nullam vulputate massa a leo mollis, nec egestas felis volutpat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Etiam congue pretium est, nec hendrerit magna rutrum non. Phasellus imperdiet ex sit amet dui bibendum pellentesque.
-->
  <blockquote style="margin:0;"  v-if="sellaReady==false">

 <div class="yo-text-n yo-bg-color-secondary white yo-align-center" style="margin-top:20px;padding:10px 0;">ISCRIZIONI DA RINNOVARE</div> 
    

      <div class="row pad-in" v-for="item in $socio._nextquote"  :key="item.id" :class="'item_'+item.id" style="margin-top:20px;margin-bottom:20px;" v-if="item.nuovo==0 && item.id!=169">
         <div class="col s3 m1  yo-align-right">
         <el-switch style="display: block" v-model="item.selezionato" :inactive-value="0" :active-value="item.importo" active-color="#13ce66" inactive-color="#ff4949" active-text="" inactive-text=""></el-switch>
         </div>
         <div class="col s9 m1m yo-align-left" >{{item.id | items($teras._societa,'sigla')}}</div>
         <div class="col m9m yo-hidden-phone" >{{item.id | items($teras._societa,'nome')}}</div>
      </div>

      <div v-if="daRinnovare==false">Lei risulta già in regola con la quota sociale per l'anno corrente.</div>

</blockquote>














  <div class="yo-text-n yo-bg-color-secondary white yo-align-center" style="margin-top:20px;padding:10px 0;">RIEPILOGO QUOTE SCELTE</div>

  <blockquote style="margin:0;"  v-if="dettaglioselezionate.length==0">
    <div style="padding:30px 10px;">
    Non si è selezionata alcuna quota da rinnovare, la preghiamo di selezionare la quota che desidera rinnovare tra quelle proposte sopra.
    </div>
  </blockquote> 


<blockquote style="margin:0;" v-if="dettaglioselezionate.length>0"> 

  Ti preghiamo di verificare le proprie scelte e confermare per procedere al pagamento.

  <!--
  <div class="row pad" style="margin-top:6px;margin-bottom:6px;" >
      <div class="col s5 m7  yo-align-right yo-text-bold" >QUOTA</div>
      <div class="col s3 m2  yo-align-center yo-text-bold">ANNO</div>
      <div class="col s4 m3  yo-align-right yo-text-bold">IMPORTO</div>
  </div>
  -->
  
  <div class="row pad-in" v-for="item in dettaglioselezionate"  :key="item.id+item.anno" :class="'item_'+item.id+'_'+item.anno" style="margin-top:6px;margin-bottom:6px;" >
      <div class="col s5 m7 yo-align-right" >{{item.id | items($teras._societa,'sigla')}}</div>
      <div class="col s3 m2  yo-align-right">{{item.anno}}</div>
      <div class="col s4 m3  yo-align-right" v-if="item.id=='100'">{{item.importo | money('€ ')}}</div>
      <div class="col s4 m3  yo-align-right" v-else>{{item.importo  | money('€ ')}}</div>
  </div>


  <div class="row pad-in" style="margin-top:16px;margin-bottom:6px;" >
      <div class="col s8 m9 yo-align-right yo-text-bold" >TOTALE QUOTE</div>
      <div class="col s4 m3 yo-align-right yo-text-bold">{{importo | money('€ ')}}</div>
  </div>
<!--

  <div class="row pad" style="margin-top:16px;margin-bottom:0px;" v-if="gdlsconto>0">
      <div class="col s4 m2 offset-m2m yo-align-left yo-text-bold" >SCONTO GDL</div>
      <div class="col s8 m2  yo-align-right yo-text-bold">{{gdlsconto | money('€ ')}}</div>
  </div>

  <div class="row pad" style="margin-top:16px;margin-bottom:0px;" v-if="sconto>0">
      <div class="col s4 m2 offset-m2m yo-align-left yo-text-bold" >SCONTO</div>
      <div class="col s8 m2  yo-align-right yo-text-bold">{{sconto | money('€ ')}}</div>
  </div>
-->


  <div class="row pad-in" style="margin-top:16px;margin-bottom:0px;">
      <div class="col s8 m9 yo-align-right yo-text-bold" >COMMISSIONE BANCARIA</div>
      <div class="col s4 m3 yo-align-right yo-text-bold">{{commissione | money('€ ')}}</div>
  </div>

  <div class="row pad-in" style="margin-top:16px;margin-bottom:6px;" >
      <div class="col s8 m9 yo-align-right yo-text-bold" >TOTALE</div>
      <div class="col s4 m3 yo-align-right yo-text-bold">{{importoSella | money('€ ')}}</div>
  </div>

  <div class="row pad" style="margin-top:20px;">

        <div class="col s12 m6 offset-m6">
              <div v-if="importoSella>parseFloat(commissione) && sellaReady==false" @click="onSella" class="yo-pointer yo-bg-color-secondary white yo-align-center" style="width:100%;border:none;height:48px;line-height:48px;">Conferma le tue scelte</div>
          </div>
      </div>
  
  </blockquote>  

  <!--
  <blockquote style="margin:0;"  v-if="sinpia==1">
    <div class="yo-text-n yo-bg-color-secondary white yo-align-center" style="padding:10px 0;">ADESIONE ADDEBITO SULLA CARTA DI CREDITO</div>
    <div style="padding:30px 10px;">
      L'importo da pagare per i rinnovi scelti è di € {{(importo)}}, se si decide di accettare l'addebito automatico ogni anno della quota SINPIA si può beneficiare dello sconto:
      <br /><br />
      50% per le quote arretrate
      <br />
      10% per le quote dal 2018 in avanti
      <br /><br />
      Desidera accettare l'addebito sulla carta di credito? (per i prossimi tre anni)

      

      <div class="row pad" style="margin-top:20px;margin-bottom:20px;" >
        <div class="col s3 m1  yo-align-right">
          <el-switch style="display: block"  v-model="addebito" :inactive-value="0" :active-value="1" active-color="#13ce66" inactive-color="#ff4949" active-text="" inactive-text=""></el-switch>
        </div>
        <div class="col s9 m11 yo-align-left" v-if="addebito==1">SI, desidero accettare l'addebito automatico per gli anni futuri</div>
        <div class="col s9 m11 yo-align-left" v-if="addebito==0">NO, desidero pagare solo per quest'anno rinunciando allo sconto</div>
      </div>

    </div>
  </blockquote>
  -->

  <blockquote style="margin:0;"  v-if="importoSella>parseFloat(commissione) && sellaReady">
    <div class="yo-text-n yo-bg-color-secondary white yo-align-center" style="padding:10px 0;">MODALITÀ DI PAGAMENTO</div>
    <div style="padding:30px 10px;">
<!--      
      L'importo da pagare è di {{importoSella | money('€ ')}}
<br /><br />
-->
      Premendo il pulsante "Procedi al pagamento" verrete reindirizzati sul sito di Banca Sella dove potrete scegliere la modalità di pagamento da voi preferita tra quelle disponibili:
      <ul>
        <li>Carta di Credito</li>
        <li style="text-align:justify;">MyBank: bonifico immediato, rende più facili e più sicuri gli acquisti su Internet. Per quanto concerne la sicurezza, MyBank vi permette di pagare su Internet senza fornire agli esercenti alcun dettaglio del vostro conto corrente o altri dati relativi al pagamento. E per quanto riguarda la semplicità, con MyBank userete il vostro sistema di Online Banking, che già conoscete, da dove potrete dare ordine alla vostra banca di effettuare il pagamento a favore dell’esercente.</li>
        <li>Bonifico bancario: solo per i clienti Banca Sella</li>
      </ul>
      
      Una volta completata la procedura sul sito di Banca Sella vi ricordiamo di non chiudere il browser e ritornare al sito cliccando sul pulsante presente a fine procedura.
    </div>

      <div class="row pad" style="margin-top:20px;">

        <div class="col s12 m8 offset-m2">
              <a :href="sellaUri" class="yo-pointer yo-bg-color-secondary white yo-align-center" style="background-color:#24A445;display:block;width:100%;border:none;height:48px;line-height:48px;">Procedi al pagamento<!-- di {{importoSella | money('€ ')}} --></a>
          </div>
      </div>
    

      
<!--
        <div class="col s12 m3" v-if="$socio.contatto.row.id==1">
            <el-button style="width:100%;"  @click="pagafinto()">PAGA FINTO</el-button>
        </div>
        -->
        
          
        
    

    </blockquote>






    <div class="clear" style="margin-top:30px;padding:30px 10px 0 10px;border-top:2px solid grey;">
      Se non si desidera completare ora il rinnovo può cliccare il pulsante "Indietro"
      </div>
    


      <div class="row clear" style="margin-top:20px;">
        <div class="col s12 m3">
            <el-button style="width:100%;"  @click="$router.push('/home')">Indietro</el-button>
        </div>

        <br /><br />&#160;<br />

      </div>







</div>
</template>

<script>
import dbItem from '../teras/dbItem'

export default {
  name: 'contatto-rinnovo',
  components: {
  },
   data () {
      return {
         selezionato:180, value5: '100'
         ,commissione: 1
         ,loading: {}
         ,versamento: {}
         ,banca: {}
         ,nextpayment: 0
         ,createToken:0

         ,addebito: 0
         
         ,sellaReady:false
         ,sellaUri:''
         ,sella: {}


      }
   },
   created () {
      //this.$teras.page.title = (this.$socio.contatto.row.id>0) ? 'Rinnovo '+this.$socio.contatto.row.id : 'Nuovo Contatto'
      console.log("MMMMM")
      console.log(this.$socio._nextquote)
      
      
      for (let item of this.$socio._nextquote){
        console.log(item)
        //if(item.id==100)
        if(item.nuovo==0 && item.id!=169)
          item.selezionato=item.importo
      }  
      
      this.online = new dbItem({table:'online'})
      this.online.new().then((data) => {
        console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ì")
        this.online.row.contatto = this.$socio.contatto.row.id
        this.online.row.inseritoil=this.$moment().format('YYYY-MM-DD HH:mm:ss')
        this.online.row.sezione = 1
        this.online.row.importo = 0
        this.online.row.browser = this.$teras.browser.name +' '+ this.$teras.browser.version +' '+ this.$teras.browser.os
        //this.online.row.mezzo = 105
        //parent.versamento.row.step = 1
      })
      
   },
  beforeDestroy () {
  },
  methods: {
    onCard(){
      this.$notify.error({title: 'Errore',message: "La procedura non è ancora attiva!!!!"});
    },
    async onSella() {
      this.sellaReady = false
      this.online.row.quote = JSON.stringify(this.dettaglioselezionate)
      this.online.row.importo = this.importoSella
      await  this.online.save()

        var shopLogin = "9111411" //PRODUZIONE
        //var shopLogin = "GESPAY71800" //TEST
        
        var args = {
          shopLogin: shopLogin
          ,uicCode: 242
          ,shopTransactionId:  this.online.row.id
          ,amount: this.importoSella //PRODUZIONE
          //,amount: 1 //TEST

          //  ,Language: 2";
            ,customInfo: 'TERAS_NOMINATIVO='+this.$socio.contatto.row.cognome+' '+this.$socio.contatto.row.nome+'*P1*TERAS_MOTIVO=Rinnovo'
        }
        var urlWS = "https://ecomms2s.sella.it/gestpay/gestpayws/WSCryptDecrypt.asmx?WSDL" //PRODUZIONE
        //var urlWS = "https://testecomm.sella.it/gestpay/gestpayws/WSCryptDecrypt.asmx?WSDL" //TEST

        

        this.$axios.post(this.$axios.apiUrl+'vue/sella',{url:urlWS,action:'Encrypt',args: args}).then((response) => {
          this.sella = response.data.data.result
          if(this.sella.TransactionResult=='OK'){
             this.sellaReady = true
             this.sellaUri =  "https://ecomm.sella.it/pagam/pagam.aspx" //PRODUZIONE
             //this.sellaUri =  "https://testecomm.sella.it/pagam/pagam.aspx" //TEST
             this.sellaUri += "?a="+shopLogin+"&b="+this.sella.CryptDecryptString
          }
          
          //this.sella = response.data.result.CryptDecryptString
          //console.log(this.sella.CryptDecryptString)
        })
        /*
        $soap = new \SOAPClient($urlWS);
        $encrypt = $soap->Encrypt($par);		
        //dump($encrypt->EncryptResult->any);	
        $xml = simplexml_load_string($encrypt->EncryptResult->any);
        //dump($xml,1);	


        
        

        */

      },

    onCancel() {
        this.$router.go(-1)
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          //console.log("CANCELLAZIONE "+this.form.cancellazione)




          this.Save()
        } else {
          return false;
        }
      });
    },
    Save(){
    }

  },
  computed: {
    importoSella: function(){
      return parseFloat(this.importo)+parseFloat(this.commissione)
    },

    dettaglioselezionate: function(){
      console.log("++++++++++++++++++++++++++DDDDD+++++++++++++++++++++++++++++++++")
      var items = []
      for (let nq of this.$socio._nextquote){
        console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++")
          console.log(nq)
        if(nq.selezionato==nq.importo ){
          
          for (let nqd of this.$socio._nextquoteDetail){
            if(nq.id==nqd.id){
              items.push(nqd)
            }
          }
          

          
        }
      }
      return items
    },

    daRinnovare: function(){
      var esito = false
         for (let item of this.$socio._nextquote){
            if(item.nuovo==0 && item.id!=169)
               esito = true
              
            
         }
         return esito

    },
    isProped: function(){
      var esito = true
         for (let item of this.$socio._nextquote){
            if(item.id==169)
               esito = false
              
            
         }
         return esito

    },

     importo: function () {
       console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++***")
         var importo = 0
         for (let item of this.$socio._nextquote){
            if(item.selezionato==item.importo){
              
                importo+=parseFloat(item.importo)
              }
            
         }
         return importo
      },








     rules:function() {
      var rulesNow = {
        old: [
          { required: true, message: 'La vecchia password è obbligatoria' }
        ],
        new: [
          { required: true, message: 'La nuova password è obbligatoria'}
        ],
        old: [
          { required: true, validator: this.oldPassword, password:this.$socio.contatto.row.password, message: 'La vecchia password non è corretta!', trigger:"change" }
        ],
        retype: [
          { required: true, validator: this.retypePassword, password:this.password.new, message: 'La nuova password non coincide con quella di controllo!', trigger:"change" }
        ]    
      }
      return rulesNow
    }
  }
}
</script>
<style>

</style>